import React from "react"
import Header from "../components/header"
import Footer from "../components/footer"

class Layout extends React.Component {

	constructor(props) {
		super(props)
		this.state = {

		}
	}

	render(){

		return(<div>

			<Header />

				{this.props.children}

			<Footer />

		</div>)
	}

}

export default Layout
